import React from 'react'
import Link from '../primitives/link';

const StyledLinkUnderline = ({ children, ...props }) => (
  <Link
    {...props}
    css={{
      position: "relative",
      transition: "0.3s",
      "&::before": {
        left: "0",
        width: "100%",
        bottom: "-2px",
        height: "1px",
        content: '""',
        position: "absolute",
        transform: "scaleX(0)",
        transition: "0.3s transform ease-out",
        backgroundColor: "currentColor",
        transformOrigin: "bottom right"
      },
      "&:hover::before": {
        right: "0",
        transform: "scaleX(1)",
        transformOrigin: "bottom left"
      },
      '&[role=group]:hover::before, [data-state="open"] .&::before': {
        right: "0",
        transform: "scale(1)",
        transformOrigin: "bottom left"
      }
    }}>
    {children}
  </Link>
);


export default StyledLinkUnderline;